import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import { useGetAgentAccess } from 'src/components/dashboard-pages/agent-insights/hook/useGetAgentAccess';
import {
  selectUser,
  selectUserRole,
} from 'src/reducers/userReducer/userReducer';
import { capitalizeFirstLetter } from 'src/utils/capitalizeFirstLetter';
import { Routes, UserRoles } from 'src/utils/enums';

export const useAgentNavigationLogic = () => {
  const { data: agentAccess } = useGetAgentAccess();
  const role = useSelector(selectUserRole);
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const location = useLocation();

  const isAgent = role === UserRoles.ROLE_AGENT;
  const agentEmail = user?.user?.email;
  const hasValidAccess =
    agentAccess && ['available', 'not_available'].includes(agentAccess);

  React.useEffect(() => {
    if (isAgent && agentEmail && hasValidAccess) {
      const targetRoute = Routes.AGENT_INSIGHT_DETAIL.replace(
        ':agentEmail',
        agentEmail,
      );

      // Check if we're already on the target page
      if (location.pathname === targetRoute) {
        return;
      }

      const searchParams = new URLSearchParams();
      searchParams.set(
        'name',
        capitalizeFirstLetter(user?.user?.given_name) ?? 'Agent',
      );

      navigate(`${targetRoute}?${searchParams.toString()}`);
    }
  }, [isAgent, agentEmail, hasValidAccess, navigate, user, location.pathname]);
};
